// import "./pdfTemplate.css" ;

// import {bootstrapText} from "./bootstrapText" ;

const PDFTemplate = (memberData) => {
    // console.log(memberData);
    const styleText = `
        .template-container {
            background-color: #fff ;
            margin : 1rem ;
            padding: 1rem ;
            font-family: sans-serif ;
            border-radius: 8px ;
            border : 1px solid #eee ;
        }

        .template-container .template-name {
            font-size: 1.5rem ;
            font-weight: 700 ;
            line-height:2;
        }
        
        .template-container .template-field {
            flex: 1 ;
            display: flex ;
            line-height: 2.5rem ;
        }
        
        .template-container .template-field .template-key {
            font-weight: 500 ;
            margin-right: 0.5rem ;
        }
        
        .template-container .template-field .template-value {
            color: #444;
        }
    ` ;
    return (`
        <style>${styleText}</style>
        <div class="template-container">
            <div class="template-name">
                ${memberData.fullName}
            </div>

            <div class="template-field">
                <div class="template-key">License Number</div>
                <div class="template-value">${memberData.licenseNumber}</div>
            </div>
            <div class="template-field">
                <div class="template-key">Role</div>
                <div class="template-value">${memberData.role}</div>
            </div>

            <div class="template-field">
                <div class="template-key">Issue</div>
                <div class="template-value">${memberData.issue}</div>
            </div>
            <div class="template-field">
                <div class="template-key">Expiry</div>
                <div class="template-value">${memberData.expiry}</div>
            </div>

            <div class="template-field">
                <div class="template-key">Email</div>
                <div class="template-value">${memberData.email}</div>
            </div>
            <div class="template-field">
                <div class="template-key">Secondary Email</div>
                <div class="template-value">${memberData.secondaryEmail}</div>
            </div>

            <div class="template-field">
                <div class="template-key">License Status</div>
                <div class="template-value" style="${memberData.licenseStatus === "Active" ? "color:green" : "color:red"}">${memberData.licenseStatus}</div>
            </div>
            <div class="template-field">
                <div class="template-key">Subscription Status</div>
                <div class="template-value" style="${memberData.licenseStatus === "Active" ? "color:green" : "color:red"}">${memberData.licenseStatus}</div>
            </div>

        </div>
    `);
};

export default PDFTemplate;
